// AUTO-GENERATED by `pnpm --filter @borradh-workspace/contracts contracts:generate`.
// DO NOT EDIT — regenerate instead. Source: Drizzle table "treatment_plan_template".
// This file is pure Zod (no drizzle-zod / database in its runtime graph).
import { z } from 'zod';
/** Response atom for the "treatment_plan_template" table (1:1 with a DB row, on the wire). */
export const treatmentPlanTemplateAtomSchema = z.object({
    id: z.string(),
    organizationId: z.string(),
    name: z.string(),
    body: z.string(),
    formId: z.string().nullable(),
    isActive: z.boolean(),
    createdAt: z.string().datetime(),
    updatedAt: z.string().datetime(),
});
//# sourceMappingURL=treatmentPlanTemplate.js.map